import React from "react";
import { ChatPage } from "./pages/chat/chat.page";

const App = () => {
  return (
    <ChatPage />
  );
}

export default App;
